module.exports = __webpack_public_path__ + "static/media/main-section.5c189ed0.svg";